import { PORTABILITY_FORM_DATA_KEY_STORAGE } from 'constants/FormConstants';
import {
	RESPONSE_PATH,
	RESPONSE_VIEW_ERROR,
	RESPONSE_VIEW_LO_SENTIMOS_PORTABILIDAD,
	RESPONSE_VIEW_PORTABILIDAD_OK,
} from 'constants/ResponseType';
import { SERVICES_RESPONSE } from 'constants/ServicesResponse';
import { MultiFormCommand } from 'services/form/MultiFormCommand';
import { StorageService } from 'services/storage-service/StorageService';
import { StorageServiceImpl } from 'services/storage-service/StorageServiceImpl';
import { PortabilityService } from './PortabilityService';
import { PortabilityServiceImpl } from './PortabilityServiceImpl';
import { DateParse } from 'utils/DateParse';
import { KnockOutDtoStatusEnum, PortabilityDtoActionIdEnum, ScoringDtoColorEnum } from 'client';
import { AuthServices } from 'services/auth/AuthServices';
import { AuthServicesImpl } from 'services/auth/AuthServicesImpl';
import { DATA_LAYER_RESPONSE_KEY } from 'constants/DataLayers';

export class MultiFormPortabilityCommandImps implements MultiFormCommand {
	private setStep: (newStepValue: number) => void;
	private setShowLoadingModal: (isShow: boolean) => void;
	private portabilityActions: Record<number, Function>;

	private storageService: StorageService;
	private cookies;
	private portabilityService: PortabilityService;
	private authServices: AuthServices;

	private knockOutActions: Record<string, Function> = {
		[KnockOutDtoStatusEnum.Bueno]: (step: number) => {
			this.NextOneStep(step);
		},
		[KnockOutDtoStatusEnum.Malo]: () => {
			window.location.href = `${RESPONSE_PATH}/${RESPONSE_VIEW_LO_SENTIMOS_PORTABILIDAD}/${DATA_LAYER_RESPONSE_KEY.PORTABILITY_MULTI_FORM_6_LO_SENTIMOS}`;
		},
	};

	private scoringActions: Record<string, Function> = {
		[ScoringDtoColorEnum.Verde]: () => {
			this.saveScoringInStorage({ color: ScoringDtoColorEnum.Verde });
		},
		[ScoringDtoColorEnum.Rojo]: () => {
			this.saveScoringInStorage({ color: ScoringDtoColorEnum.Rojo });
		},
		[ScoringDtoColorEnum.Naranjo]: () => {
			this.saveScoringInStorage({ color: ScoringDtoColorEnum.Naranjo });
		},
		[ScoringDtoColorEnum.Amarillo]: () => {
			this.saveScoringInStorage({ color: ScoringDtoColorEnum.Amarillo });
		},
		[ScoringDtoColorEnum.Morado]: () => {
			this.saveScoringInStorage({ color: ScoringDtoColorEnum.Morado });
		},
	};

	constructor(
		setStep: (newStepValue: number) => void,
		setShowLoadingModal: (isShow: boolean) => void
	) {
		this.setStep = setStep;
		this.setShowLoadingModal = setShowLoadingModal;

		this.storageService = new StorageServiceImpl();
		this.cookies = document.cookie.split(';');
		this.portabilityService = new PortabilityServiceImpl();
		this.authServices = new AuthServicesImpl();

		this.portabilityActions = {
			0: (step: number, formData: any) => {
				this.deleteFormStorage();
				this.resetIdAndStatus();
				this.saveFormInStorage(formData);
				this.NextOneStep(step);
			},

			1: (step: number, formData: any) => {
				formData.gidnew  = this.getItemValueFromCookies('_ga_MCPHL42NFF', true);
				formData.gid = this.getItemValueFromCookies('_ga');
				formData.fbc = this.getItemValueFromCookies('_fbc');
				formData.fbp = this.getItemValueFromCookies('_fbp');
				formData.userAgent = navigator.userAgent;

				this.saveFormInStorage(formData);
				this.resetIdAndStatus();
				this.createForm(step);
			},

			2: (step: number, formData: any) => {
				formData.gidnew  = this.getItemValueFromCookies('_ga_MCPHL42NFF', true);
				formData.gid = this.getItemValueFromCookies('_ga');
				formData.fbc = this.getItemValueFromCookies('_fbc');
				formData.fbp = this.getItemValueFromCookies('_fbp');
				formData.userAgent = navigator.userAgent;
				this.saveFormInStorage(formData);
				formData.actionId = undefined;				
				this.setShowLoadingModal(true);
				this.updateOnService(formData, () => {
					this.NextOneStep(step);
					this.setShowLoadingModal(false);
				});

			},

			3: (step: number, formData: any) => {
				formData.gidnew  = this.getItemValueFromCookies('_ga_MCPHL42NFF', true);
				formData.gid = this.getItemValueFromCookies('_ga');
				formData.fbc = this.getItemValueFromCookies('_fbc');
				formData.fbp = this.getItemValueFromCookies('_fbp');
				formData.userAgent = navigator.userAgent;
				this.saveFormInStorage(formData);

				formData.actionId = undefined;

				this.setShowLoadingModal(true);
				this.updateOnService(formData, () => {
					this.NextOneStep(step);
					this.setShowLoadingModal(false);
				});
			},

			4: (step: number, formData: any) => {
				formData.gidnew  = this.getItemValueFromCookies('_ga_MCPHL42NFF', true);
				formData.gid = this.getItemValueFromCookies('_ga');
				formData.fbc = this.getItemValueFromCookies('_fbc');
				formData.fbp = this.getItemValueFromCookies('_fbp');
				formData.userAgent = navigator.userAgent;
				this.saveFormInStorage(formData);

				formData.actionId = PortabilityDtoActionIdEnum.Scoring;

				this.setShowLoadingModal(true);
				this.updateOnService(formData, (data: { scoring: { color: string } }) => {
					const { color } = data?.scoring;

					this.scoringActions[color]();
					this.NextOneStep(step);
					this.setShowLoadingModal(false);
				});
			},

			5: (step: number, formData: any) => {
				formData.gidnew  = this.getItemValueFromCookies('_ga_MCPHL42NFF', true);
				formData.gid = this.getItemValueFromCookies('_ga');
				formData.fbc = this.getItemValueFromCookies('_fbc');
				formData.fbp = this.getItemValueFromCookies('_fbp');
				formData.userAgent = navigator.userAgent;
				this.saveFormInStorage(formData);

				formData.actionId = PortabilityDtoActionIdEnum.Finish;

				this.setShowLoadingModal(true);
				this.updateOnService(formData, () => {
					this.setShowLoadingModal(false);

					const color = this.storageService.getFromStoreObject(
						'scoring',
						'color',
						sessionStorage
					) as string;

					this.deleteStorage();
					this.finishRedirect(color);
				});
			},
		};
	}
	execute(step: number, formData: any): void {
		throw new Error('Method not implemented.');
	}
	setLoadingModalControl(setShowLoadingModal: (isShow: boolean) => void): void {
		throw new Error('Method not implemented.');
	}
	setStepControl(stepControl: any): void {
		throw new Error('Method not implemented.');
	}
	getStep(): number {
		return 0;
	}

	backToPortabilityHomePage(): void {
		window.location.href = `${process.env.REACT_APP_WORDPRESS_URL}/portabilidad-financiera`;
	}

	finishRedirect(color?: string) {
		const redirect =
			color === ScoringDtoColorEnum.Rojo || color === ScoringDtoColorEnum.Naranjo
				? `${RESPONSE_PATH}/${RESPONSE_VIEW_LO_SENTIMOS_PORTABILIDAD}/${DATA_LAYER_RESPONSE_KEY.PORTABILITY_MULTI_FORM_6_LO_SENTIMOS}`
				: `${RESPONSE_PATH}/${RESPONSE_VIEW_PORTABILIDAD_OK}/${DATA_LAYER_RESPONSE_KEY.PORTABILITY_MULTI_FORM_6_EXITO}`;
		window.location.href = redirect;
	}

	saveFormInStorage(formData: any): void {
		this.storageService.setToStoreObject(
			PORTABILITY_FORM_DATA_KEY_STORAGE,
			formData,
			sessionStorage
		);
	}
	saveScoringInStorage(color: Object): void {
		this.storageService.setToStoreObject('scoring', color, sessionStorage);
	}

	deleteStorage(): void {
		this.storageService.deleteAllStorage(sessionStorage);
	}

	deleteFormStorage(): void {
		this.storageService.deleteKey(PORTABILITY_FORM_DATA_KEY_STORAGE, sessionStorage);
	}

	resetIdAndStatus(): void {
		this.storageService.deleteItemOnStoreObject(
			PORTABILITY_FORM_DATA_KEY_STORAGE,
			'id',
			sessionStorage
		);
		this.storageService.deleteItemOnStoreObject(
			PORTABILITY_FORM_DATA_KEY_STORAGE,
			'version',
			sessionStorage
		);
	}

	getItemValueFromCookies(key: string, startsWith: boolean = false): string | undefined {
		const cookies = document.cookie.split(';').map(cookie => cookie.trim());
		if (startsWith) {
			return cookies.find(value => value.startsWith(key))?.split('=')[1];
		} else {
			return cookies.find(value => value.includes(key))?.split('=')[1];
		}
	}

	createForm(step: number): void {
		let formData = this.storageService.getAllFromStoreObject(
			PORTABILITY_FORM_DATA_KEY_STORAGE,
			sessionStorage
		);
		formData = this.formatFormData(formData);

		this.setShowLoadingModal(true);
		this.portabilityService
			.CreatePortabilityData(
				this.storageService.getFromStoreObject('session', 'token', sessionStorage) as string,
				formData
			)
			.then((response) => {
				const { status, ...data } = response?.data;
				this.storageService.setToStoreObject(
					PORTABILITY_FORM_DATA_KEY_STORAGE,
					data,
					sessionStorage
				);
				if (status === SERVICES_RESPONSE.CREATED) {
					this.NextOneStep(step);
				} else {
					window.location.href = `${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/${DATA_LAYER_RESPONSE_KEY.PORTABILITY_MULTI_FORM_6_ERROR}`;
				}
				this.setShowLoadingModal(false);
			})
			.catch((error) => {
				this.hadledPortabilityError(error);
			});
	}

	private getPortabilityIdFromStorage(): number {
		const id = this.storageService.getFromStoreObject(
			PORTABILITY_FORM_DATA_KEY_STORAGE,
			'id',
			sessionStorage
		) as number;
		return id === null ? 0 : id;
	}

	private getPortabilityVersionFromStorage(): number {
		const id = this.storageService.getFromStoreObject(
			PORTABILITY_FORM_DATA_KEY_STORAGE,
			'version',
			sessionStorage
		) as number;
		return id === null ? 0 : id;
	}

	private updateOnService(formData: any, callback: any): void {
		formData.version = this.getPortabilityVersionFromStorage();
		formData.id = this.getPortabilityIdFromStorage();

		formData = this.formatFormData(formData);

		if (formData.id > 0) {
			this.portabilityService
				.UpdatePortabilityData(
					this.storageService.getFromStoreObject('session', 'token', sessionStorage) as string,
					formData.id,
					formData
				)
				.then((response) => {
					const { version, status } = response?.data;
					if (status === SERVICES_RESPONSE.UPDATED) {
						this.storageService.setToStoreObject(
							PORTABILITY_FORM_DATA_KEY_STORAGE,
							{ version: version },
							sessionStorage
						);
						callback(response?.data);
					}
				})
				.catch((error) => {
					this.hadledPortabilityError(error);
				});
		}
	}

	hadledPortabilityError(error: any): void {
		if (error.response && error.response.status === 401) {
			this.deleteStorage();
			window.location.reload();
		} else {
			window.location.href = `${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/${DATA_LAYER_RESPONSE_KEY.PORTABILITY_MULTI_FORM_6_ERROR}`;
		}
	}

	backOneStep(step: number): void {
		this.setStep(step - 1);
	}
	NextOneStep(step: number): void {
		this.setStep(step + 1);
	}

	saveForm(step: number, formData: any): void {
		this.portabilityActions[step](step, formData);
	}
	updateForm(step: number, formData: any): void {
		throw new Error('Method not implemented.');
	}

	async login(): Promise<void> {
		this.setShowLoadingModal(true);
		this.storageService.deleteKey('session', sessionStorage);
		await this.authServices
			.login()
			.then((response) => {
				const { token } = response.data;
				this.storageService.setToStoreObject(
					'session',
					{ token: `Bearer ${token}` },
					sessionStorage
				);
				this.setShowLoadingModal(false);
			})
			.catch((error) => {
				window.location.href = `${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/${DATA_LAYER_RESPONSE_KEY.PORTABILITY_MULTI_FORM_6_ERROR}`;
			});
	}

	formatFormData(formData: any): any {
		let formatedFormData = formData;
		if (formatedFormData.dateOfEmployment) {
			formatedFormData.dateOfEmployment = DateParse(formatedFormData.dateOfEmployment);
		}
		if (formatedFormData.nationalId) {
			formatedFormData.nationalId = formatedFormData.nationalId.replaceAll('.', '');
		}
		if (formatedFormData.vehiclePlate) {
			formatedFormData.vehiclePlate = [formatedFormData.vehiclePlate];
		}

		if (formatedFormData.financialInstitutionName === 'other') {
			formatedFormData.financialInstitutionName = formatedFormData.otherFinancialInstitution;
			formatedFormData.otherFinancialInstitution = undefined;
		}
		return formatedFormData;
	}
}
